import type { ReactNode } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


/**
 * md sits within a line of text, lg beside a heading or a button's
 * label. Both are em, so the icon scales with the text around it.
 */
export type InlineIconSize = "md" | "lg";

const SIZE_CLASSES: Record<InlineIconSize, string> = {
    md: "size-[1.25em]",
    lg: "size-[1.5em]",
};


interface InlineIconProps {
    size?: InlineIconSize;
    className?: string;
    /** One image or SVG, which is stretched to fill the icon's box. */
    children: ReactNode;
}


/** An image or SVG sized to sit within a line of text. */
export function InlineIcon({ size = "md", className, children }: InlineIconProps) {
    return (
        <span className={cn(
            "inline-block shrink-0 align-middle leading-none",
            "*:size-full *:max-w-none *:object-contain",
            SIZE_CLASSES[size],
            className ?? null,
        )}>
            {children}
        </span>
    );
}
